import { Box, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';

import { Inquiry } from '../models/inquiry';

/**
 * Offers handed in of the suppliers asked, each supplier once (#2260), in the
 * inquiry list and in the cockpit alike (#2340).
 */
export const PaloOfferCountCell = ({ count }: { count: Inquiry['offerCount'] }): ReactElement =>
    count ? (
        <Tooltip
            placement="top"
            title={
                <FormattedMessage
                    id="app.inquiries.offerCount.tooltip"
                    values={{
                        submitted: count.submitted,
                        declined: count.declined,
                        open: count.asked - count.submitted - count.declined,
                    }}
                />
            }
        >
            <Box component="span">
                {count.submitted}/{count.asked}
            </Box>
        </Tooltip>
    ) : (
        <>–</>
    );
